import { CalculatedPrice } from '@/modules/store/models/Price';
import { formatPrice } from '@/utils/currency';

interface PriceProps {
  price?: CalculatedPrice;
}

const Price = ({ price }: PriceProps) => {
  if (!price) return null;

  const { discountedPrice, originalPrice } = price;

  const hasDiscount = discountedPrice && discountedPrice.amount !== originalPrice.amount;

  return hasDiscount ? (
    <span>
      <span>{formatPrice(discountedPrice)}</span>{' '}
      <span className="strikethrough-diagonal">{formatPrice(originalPrice)}</span>
    </span>
  ) : (
    <span>{formatPrice(price)}</span>
  );
};

export default Price;
